// Service business-area as set in the SAP account data (field: BusinessArea)
export enum ServiceBusinessAreaKey {
  B2BApp = "B2BAPP",
  CustomerData = "CUSTOMERDATA",
  EquiVolt = "EQUIVOLT",
  Fbs = "FBS",
  Gaas = "GAAS",
  GasesShop = "GASESSHOP",
  ThgQuote = "GHG",
  Mobility = "MOBILITY",
  Petrol = "PETROL",
  Virta = "VIRTA",
  Wcc = "WCC",
  Wsc = "WSC",
  WestfalenId = "WESTFALEN.ID",
}

export const mapToServiceBusinessAreaKeyEnum = (
  key: string,
): ServiceBusinessAreaKey => {
  if (
    Object.values(ServiceBusinessAreaKey).includes(
      key as ServiceBusinessAreaKey,
    )
  )
    return key as ServiceBusinessAreaKey;

  throw new Error(`Unknown ServiceBusinessAreaKey: ${key}`);
};
